import { render, staticRenderFns } from "./Alk.vue?vue&type=template&id=cc3bca14&scoped=true"
import script from "./Alk.vue?vue&type=script&lang=js"
export * from "./Alk.vue?vue&type=script&lang=js"
import style0 from "./Alk.vue?vue&type=style&index=0&id=cc3bca14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3bca14",
  null
  
)

export default component.exports